export default {"src":"/_next/static/media/level_4.c5861cb0.svg","height":128,"width":128,"blurWidth":0,"blurHeight":0};